import { Form, FormHandlers, FormProps } from '@doveit/bricks';
import React from 'react';
import upsertPropertySpaceValidationSchema from './UpsertPropertySpaceForm.schema';

export interface UpsertPropertySpaceFormModel {
  size: string,
  floor: string,
}

export interface UpsertPropertySpaceFormProps {
  space: 'balcony' | 'cellar' | 'terrace' | 'garden',
  initialValues?: Partial<UpsertPropertySpaceFormModel>,
  disabled?: boolean,
  innerRef?: React.MutableRefObject<FormHandlers>,
  loading?: FormProps<UpsertPropertySpaceFormModel>['loading'],
  onSubmit: FormProps<UpsertPropertySpaceFormModel>['onSubmit'],
}

const UPSERT_PROPERTY_SPACE_FORM_DEFAULT_VALUES: UpsertPropertySpaceFormModel = {
  size: '',
  floor: '',
};

const UpsertPropertySpaceForm: React.FC<UpsertPropertySpaceFormProps> = ({
  space,
  initialValues = {},
  ...rest
}) => {
  const mergedInitialValues: UpsertPropertySpaceFormModel = {
    ...UPSERT_PROPERTY_SPACE_FORM_DEFAULT_VALUES,
    ...initialValues,
  };

  return (
    <Form
      initialValues={mergedInitialValues}
      validationSchema={upsertPropertySpaceValidationSchema(space)}
      {...rest}
    >
      <Form.Item size={{ MD: space === 'garden' ? 1 : 1 / 2 }}>
        <Form.Input
          size="S"
          name="size"
          type="number"
          min="0"
          aria-label="Campo per specificare la dimensione dello spazio"
          placeholder="Es. 200"
          prefixElement="m²"
          hasErrorTooltip
          required={space === 'garden'}
        />
      </Form.Item>

      {space !== 'garden' && (
        <Form.Item size={{ MD: 1 / 2 }}>
          <Form.Input
            size="S"
            name="floor"
            type="number"
            aria-label="Campo per specificare il piano dello spazio"
            placeholder="Es. 1"
            prefixElement="Piano"
            hasErrorTooltip
          />
        </Form.Item>
      )}
    </Form>
  );
};

export default UpsertPropertySpaceForm;
